import { Component, OnInit, Input, EventEmitter, Output, ViewChild, OnDestroy } from '@angular/core';
import { ApiService } from '../../api.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';
import { ProfileService } from '../../profile.service';
import { Subscription } from 'rxjs';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  hide = true;
  hide1 = true;
  hide2 = true;
  dataToPass;
  passwordForm: UntypedFormGroup;
  submitted: boolean = false;
  showLableView: boolean = false;
  confirmPassword: boolean = false;
  confirmPasswordVal;
  @ViewChild('confirmPasswordModel') confirmPasswordModel;
  @ViewChild('confirmationModal') confirmationModal;
  public barLabel: string = "Strength:";
  tokenKey: string;
  modalRef: BsModalRef;
  @Input() clientId;
  @Input() clientSecret;
  @Input() logOutUrl;
  @Input() username;
  @Output() dataEvent = new EventEmitter();
  subscription: Subscription;
  langSubscription: Subscription;
  public strengthLabels = [
    'Too weak',
    'Weak',
    'Fair',
    'Good',
    'Strong'
  ];

  errorMessageLength = '';
  errorMessageUpper = '';
  errorMessageLower = '';
  errorMessageSpecial = '';
  errorMessageMarked = '';
  errorMessageTypo = '';
  errorMessageNumber = '';
  specialCharacters = '\\ !?@#~%"#$%&\/=\'^*+-_`.,:;()[]{}';
  markedChars = ''
  firstMarkedChar = '';
  firstTypoChar = '';
  showErrors = false;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(public layoutService: PHBHPLayoutPackageService, private userService: ProfileService, public dialog: MatDialog, private formbuilder: UntypedFormBuilder,
    private apiService: ApiService, private modalService: BsModalService) { }

  ngOnInit() {
    this.passwordForm = this.formbuilder.group({
      currentPassword: ["", Validators.required],
      newPassword: ["", Validators.required],
      confirmPasswordVal1: ["", Validators.required],
    })
    this.strengthLabels = [
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthTooWeak),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthWeak),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthFair),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthGood),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthStrong)
    ];
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.strengthLabels = [
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthTooWeak),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthWeak),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthFair),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthGood),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthStrong)
      ];
    })
    this.subscription = this.userService.profileTabIndex$.subscribe((data) => {
      this.submitted = false;
      this.passwordForm.reset();
    });

    this.passwordForm.controls.newPassword.valueChanges.subscribe((val) => {
      console.log(val);
      console.log(this.passwordForm.get('newPassword').valid);
      console.log(this.passwordForm.get('newPassword').errors)
    });
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
  get f() {
    return this.passwordForm.controls;
  }
  encryptUsingAES256(data: any) {
    let _key = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let _iv = CryptoJS.enc.Utf8.parse(this.apiService.tokenKey);
    let encrypted = CryptoJS.AES.encrypt(
      data, _key, {
      keySize: 128 / 8,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  changePassword() {
    this.modalRef = this.modalService.show(this.confirmationModal, Object.assign({}, { class: 'w-420' }));
  }

  passwordFun() {
    this.submitted = true;
    //Validators.pattern('(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !"#$%&\'()\\\\*+,-./:;<=>?@[\\\]^_`{|}~]).{8,}')
    var valid = true;
    // this.checkPassword(this.passwordForm.value.newPassword);
    if (this.passwordForm.invalid) {
      return;
    }
    /*if (this.confirmPasswordModel.invalid) {
      return false;
    }*/
    //if(this.passwordForm.value.newPassword != this.confirmPasswordVal) {
    if (this.passwordForm.value.newPassword != this.passwordForm.value.confirmPasswordVal1) {
      this.confirmPassword = true;
      return;
    } else {
      this.confirmPassword = false;
    }
    this.changePassword();
  }
  showStrengthLable(e: string) {
    if (e.length > 0) {
      this.showLableView = true;
    } else {
      this.showLableView = false;
    }
    //if(this.passwordForm.value.newPassword == this.confirmPasswordVal) {
    if (this.passwordForm.value.newPassword == this.passwordForm.value.confirmPasswordVal1) {
      this.confirmPassword = false;
      this.passwordForm.controls.confirmPasswordVal1.setErrors(undefined);
    } else {
      this.confirmPassword = true;
      this.passwordForm.controls.confirmPasswordVal1.setErrors({ 'incorrect': true });
    }
  }

  checkPassword(text) {
    var expUpper = /(?=.*?[A-Z])/; //uppercase
    var expLower = /(?=.*?[a-z])/; //lowercase
    var expNumber = /(?=.*?[0-9])/i; // number
    var expSpecial = /(?=.*?[ !#$%&\'()\\*+,-.\/:;=?@[\]^_`{|}~])/i; //(){}[]|`|! "$%^&*":;#~_-+=,@€
    var markedChars = /(?=.*?[À-ÿ])|(?=.*?[ŔŕŞşŢţȚțŬŭǓǔŮůǗǘǛǜǙǚǕǖŰűŨũṸṹŲųŪūṺṻỦủȔȕȖȗƯưỨứỪừỮữỬửỰựỤụṲṳṶṷṴṵɄʉᵾᶙĪīꜶꜷȢȣᵫĮįČčĎďĚěŇňŘřŠšŤťŮůÝýŽžẞßÆæŒœĀāǢǣĒēŌōȲȳŐőĂăĄąĐđǴǵĞğĶķĻļŁłĹĺĽľĻļḶḷŹźẐẑŽžŻżẒẓẔẕŃńǸǹŇň])/; // marked chars
    var typographicalChars = /(?=.*?[×÷·•≈❦❧⟨⟩⁂‰‱‸⁁⎀€£<>¬◌̂©¤†‡⌀⹀⸗℮ºª♀♂⚥«»‽¶±®§℠℗∴™⁀⸿፠๛])/; // typographical chars

    var valid = true;

    this.errorMessageLength = '';
    this.errorMessageUpper = '';
    this.errorMessageLower = '';
    this.errorMessageSpecial = '';
    this.errorMessageNumber = '';
    this.errorMessageMarked = '';
    this.errorMessageTypo = '';
    this.firstMarkedChar = '';
    this.firstTypoChar = '';
    // 'ERROR_MESSAGES.REQUIRED.PASSWORD_CHANGE.NEW' | translate 
    if (text.length < 8) {
      this.errorMessageLength = 'AUTHORIZATION.PASS_VERIFY.LENGTH';
      valid = false;
    }
    if (!text.match(expUpper)) {
      this.errorMessageUpper = 'AUTHORIZATION.PASS_VERIFY.UPPERCASE';
      valid = false;
    }
    if (!text.match(expLower)) {
      this.errorMessageLower = 'AUTHORIZATION.PASS_VERIFY.LOWERCASE';
      valid = false;
    }
    if (!text.match(expNumber)) {
      this.errorMessageNumber = 'AUTHORIZATION.PASS_VERIFY.NUMBER';
      valid = false;
    }
    if (!text.match(expSpecial)) {
      this.errorMessageSpecial = 'AUTHORIZATION.PASS_VERIFY.SPECIAL';
      valid = false;
    }
    if (text.match(markedChars)) {
      this.errorMessageMarked = 'AUTHORIZATION.PASS_VERIFY.MARKED';
      var res = /([À-ÿ]|[ŔŕŞşŢţȚțŬŭǓǔŮůǗǘǛǜǙǚǕǖŰűŨũṸṹŲųŪūṺṻỦủȔȕȖȗƯưỨứỪừỮữỬửỰựỤụṲṳṶṷṴṵɄʉᵾᶙĪīꜶꜷȢȣᵫĮįČčĎďĚěŇňŘřŠšŤťŮůÝýŽžẞßÆæŒœĀāǢǣĒēŌōȲȳŐőĂăĄąĐđǴǵĞğĶķĻļŁłĹĺĽľĻļḶḷŹźẐẑŽžŻżẒẓẔẕŃńǸǹŇň])/.exec(text);
      if (res && res.length > 0) {
        this.firstMarkedChar = res[0];
        valid = false;
      }
    }
    if (text.match(typographicalChars)) {
      this.errorMessageTypo = 'AUTHORIZATION.PASS_VERIFY.TYPOGRAPHICAL';
      var res = /([×÷·•≈❦❧⟨⟩⁂‰‱‸⁁⎀€£<>¬◌̂©¤†‡⌀⹀⸗℮ºª♀♂⚥«»‽¶±®§℠℗∴™⁀⸿፠๛])/.exec(text);
      if (res && res.length > 0) {
        this.firstTypoChar = res[0];
        valid = false;
      }
    }
    if (valid) {
      this.showErrors = false;
      this.passwordForm.controls.newPassword.setErrors(undefined);
    } else {
      this.showErrors = true;
      this.passwordForm.controls.newPassword.setErrors({ 'incorrect': true });
    }

  }

  changeUpdatedPassword() {
    var data = {
      username: this.username,
      oldPassword: this.encryptUsingAES256(this.passwordForm.value.currentPassword),
      newPassword: this.encryptUsingAES256(this.passwordForm.value.newPassword),
      clientId: this.clientId,
      clientSecret: this.clientSecret
    }
    this.apiService.changePassword(data).subscribe({
      next: res => {
        if (res) {
          this.passwordForm.reset();
          this.confirmPasswordVal = "";
          this.submitted = false;
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
          this.dataEvent.emit({ event: 'changePasswordSuccess' });
          this.showLableView = false;
          setTimeout(() => {
            this.userService.logout();
            window.location.href = this.logOutUrl;
          }, 2000);
        } else {
          this.passwordForm.reset();
          this.confirmPasswordVal = "";
          this.showLableView = false;
          this.submitted = false;
          this.dataEvent.emit({ event: 'changePasswordFailure' })
        }
      },
      error: err => {
        if (err.error.message != '') {
          this.passwordForm.reset();
          this.showLableView = false;
          this.confirmPasswordVal = "";
          this.submitted = false;
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
          this.dataEvent.emit({ event: 'error', message: err.error.message })
        }
      }
    })
  }
  changeMHSPassword() {
    this.layoutService.showLoader = true;
    var data = {
      Username: this.username,
      OldPassword: this.passwordForm.value.currentPassword,
      NewPassword: this.passwordForm.value.newPassword
    }
    this.apiService.changeMHSPassword(data).subscribe({
      next: res => {
        // this.passwordForm.reset();
        // this.confirmPasswordVal = "";
        this.showLableView = false;
        if (!res) {
          this.submitted = false;
          this.layoutService.showLoader = false;
          this.dataEvent.emit({ event: 'changePasswordFailure' });
        } else {
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
          this.dataEvent.emit({ event: 'changePasswordSuccess' });
          this.showLableView = false;
          setTimeout(() => {
            this.layoutService.showLoader = false;
            this.userService.logout();
            window.location.href = this.logOutUrl;
          }, 2000);
        }
      },
      error: err => {
        if (err.error.message != '') {
          this.passwordForm.reset();
          this.showLableView = false;
          this.confirmPasswordVal = "";
          this.submitted = false;
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
          //this.dataEvent.emit({event:'error',message:err.error.message})
        }

        this.layoutService.showLoader = false;
      }
    })
  }
}
